import {createCookie} from './cookie.js';

(function( $ ) {

  $('a[href="#"]').click(function(e){
    e.preventDefault()
  });

  $('.menu-button, .menu-container .close').click(function(){
    $('.menu-container').fadeToggle(350);
  });

  $('.contact-open, .contact-container .close').click(function(e){
    $('.menu-container').fadeOut(350);
    $('.contact-container').fadeToggle(350);
    e.preventDefault();
  });
  
  $(".cookies-close").click(function () {
    createCookie('cookies-accepted', 'yes', 31);
    $(".cookies-regulation").animate({bottom:-350}, 600).fadeOut();
    return false;
  });

  $('.scroll-down').click(function(){
    $('html, body').animate({
      scrollTop: $(".main").offset().top - 60
    }, 500);
    return false;
  });

  $('.book-now').click(function(){
    $('.submenu.sticky a').last().click();
  });

  $('.gigs-tabs h3 a').click(function(){
    $('.gigs-tabs h3 a').removeClass('active');
    $(this).addClass('active');
    $('.gigs-container').removeClass('active');
    let container = $(this).data('gigs');
    $('.gigs-container.'+ container).addClass('active');
    return false;
  });

  $('.single-artists .submenu.sticky a').click(function(){
    $('.submenu.sticky a').removeClass('active');
    $(this).addClass('active');
    $('html, body').animate({
      scrollTop: $('.' + $(this).data('container')).offset().top - 60
    }, 500);
  });
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partial/links.js